// extracted by mini-css-extract-plugin
module.exports = {"shippedBy":"shipped-by_shippedBy__zyaQc","infoTrigger":"shipped-by_infoTrigger__KeuXX","sheetDescription":"shipped-by_sheetDescription__iHtRE","nowrap":"shipped-by_nowrap__AIC5_"};